export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function queue() {
  return delay(0);
}
